const getters = {
  // name: state => state.user.name,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userId: state => state.user.userInfo.id
}
export default getters
